
export enum ProCheckoutTypeCd {
	CUSTOMER = 'Customer',
	DRIVER = 'Driver'}

